import React, { Component } from 'react';
import {
  Text,
  View,
  Pressable,
  StyleSheet,
  ActivityIndicator,
  TouchableWithoutFeedback,
  Keyboard,
  Image,
} from 'react-native';

import OPComponent from './op_component';
import SearchInput from './search_input';
import KeyboardAvoidingFlatList from '../components/keyboard_avoiding_flatlist';
import { COLOR, FONT, FONT_SIZE, THEME, __WEB__ } from '../../constants/styles';

class ItemSeparator extends Component {
  render() {
    return <View style={styles.itemSeparator} />;
  }
}

export default class SuggestionList extends OPComponent {
  constructor(props) {
    super(props);

    this.state = {
      value: props.defaultValue || null,
      items: !props.searchMode ? props.items : [],
      showOverlay: false,
    };

    this._staticItems = !!props.items;
    this._inputRef = React.createRef();
  }

  componentDidMount() {
    if (this.props.autoFocus !== false) {
      setTimeout(() => {
        this._inputRef?.current?.focusInput();
      }, 300);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.externalValue !== this.props.externalValue) {
      this.handleChangeText(this.props.externalValue);
    }
  }

  selectItem(item) {
    if (!this.props.closeOnSelect && !this.props.searchMode) this._handleValue(item.label);

    this.props.onValue && this.props.onValue({ value: item.label, item });

    Keyboard.dismiss();

    if (this.props.searchMode) {
      this.setState({
        value: null,
        items: [],
        showOverlay: false,
      });
      this.clear();
    }
  }

  setItems(items) {
    this.setState({ items });
  }

  filteredItems(value) {
    value = value || '';
    if (this.props.searchMode && !value) return [];

    var regExp = new RegExp(value, 'gi');
    return this.props.items.filter(({ label }) => `${label}`.match(regExp));
  }

  handleChangeText = (value) => {
    this._handleValue(value);

    this.props.onValue({ value });
  };

  _handleValue(value) {
    if (this._staticItems) {
      let items = this.filteredItems(value);
      this.setState({ value, items });
    } else {
      this.setState({ value });
    }
  }

  renderItem = ({ item, index }) => {
    if (this.props.renderItem) {
      return (
        <Pressable onPress={() => this.selectItem(item)}>{this.props.renderItem(item)}</Pressable>
      );
    }
    return (
      <View style={styles.rowBackground}>
        <Pressable style={styles.row} onPress={() => this.selectItem(item)}>
          <Text style={styles.labelText}>{item.label}</Text>
          {!!this.props.selectedId && this.props.selectedId == item.id && (
            <Image
              style={{ width: 30, height: 24, tintColor: COLOR.greenColor }}
              source={require('../../../resources/check.png')}
            />
          )}
        </Pressable>
      </View>
    );
  };

  handleOverlayPress = () => {
    this.clear();
  };

  renderOverlay() {
    if (!this.props.searchMode || !this.state.showOverlay || this.props.noOverlay) return null;
    return (
      <TouchableWithoutFeedback onPress={this.handleOverlayPress}>
        <View style={styles.overlay} />
      </TouchableWithoutFeedback>
    );
  }

  clear = () => {
    this._inputRef?.current?.clearInput();
    this.setState({ showOverlay: false });
    this.handleChangeText('');
    Keyboard.dismiss();
  };

  handleFocus = () => {
    this.setState({ showOverlay: true });
  };

  renderList = () => {
    if (!this.state.items?.length) return null;

    return (
      <View style={this.props.containerStyle}>
        <KeyboardAvoidingFlatList
          data={this.state.items}
          renderItem={this.renderItem}
          keyboardShouldPersistTaps="handled"
          keyExtractor={(item, index) => `item_${index}`}
          ItemSeparatorComponent={this.props.itemSeparatorComp || ItemSeparator}
          extraPadding={this.props.inverted ? 0 : 60}
        />
      </View>
    );
  };

  render() {
    let value = this.state.value;
    const props = this.props;

    const justifyStyle = {
      justifyContent: props.inverted ? 'flex-end' : 'flex-start',
    };

    return (
      <View
        style={{
          flex: 1,
          backgroundColor: 'transparent',
          justifyContent: props.inverted ? 'flex-end' : 'flex-start',
        }}
        pointerEvents="box-none"
      >
        {this.renderOverlay()}
        <View
          style={[
            props.searchMode ? styles.searchContainer : styles.container,
            props.innerContainerStyle,
          ]}
        >
          {!props.hideInput && (
            <View style={[styles.inputContainerContainer, this.props.inputContainerStyle]}>
              <SearchInput
                ref={this._inputRef}
                placeholder={'Start typing...'}
                handleChangeText={this.handleChangeText}
                onSubmit={null}
              />
            </View>
          )}
          {!!this.props.showSpinner && (!this.state.items || !this.state.items.length) && (
            <ActivityIndicator animating={true} size="large" color="gray" />
          )}

          {this.renderList()}
        </View>
      </View>
    );
  }
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: COLOR.altContrast,
  },
  searchContainer: {
    paddingTop: 0,
    marginHorizontal: 0,
    marginTop: 0,
    marginBottom: 0,
  },
  input: THEME.input,
  rowBackground: {
    height: 71,
    backgroundColor: COLOR.altContrast,
  },
  row: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: COLOR.contrast,
    paddingHorizontal: 25,
    height: 71,
    marginTop: -1,
  },
  labelText: {
    flex: 1,
    ...FONT.regular,
    fontSize: FONT_SIZE.large,
    color: COLOR.text,
  },
  inputContainerContainer: {
    backgroundColor: 'rgb(241, 241, 241)',
    paddingHorizontal: 10,
    paddingVertical: 10,
  },
  inputContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: COLOR.contrast,
    marginHorizontal: 10,
    marginBottom: 10,
    marginTop: 10,
    borderBottomWidth: 0,
    borderRadius: 10,
    paddingHorizontal: 10,
  },
  searchIcon: {
    width: 20,
    height: 20,
    tintColor: COLOR.textLight,
    marginRight: 10,
    marginTop: 5,
  },
  itemSeparator: {
    height: 2,
    backgroundColor: COLOR.altContrast,
  },
  overlay: {
    position: 'absolute',
    top: 0,
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: COLOR.overlay,
  },
});
